// frontend/src/services/upload.js
import { apiClient } from '../api/index';

const uploadService = {
  /**
   * Uploads a file to the backend.
   * @param {File} file - The file object to upload (already compressed).
   * @param {string} folder - The target folder in storage (default: 'misc').
   * @returns {Promise<Object>} - The response containing the public URL.
   */
  uploadImage: async (file, folder = 'misc') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);

    // The apiClient will detect FormData and handle headers automatically
    return await apiClient.post('/upload/', formData);
  }
};

export default uploadService;